import { useEffect } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import { useLogUser } from '@hungryroot/customer';
import { fullPageRedirect } from '@hungryroot/environment';
import { useLogExperiments } from '@hungryroot/experiments';
import {
  BUILDING_PATH,
  Building,
  useFunnelRedirects,
} from '@hungryroot/funnel';
import { initializeDatadog } from '@hungryroot/o11y';
import { ROUTE_CYO } from '@hungryroot/page-cyo';
import { ROUTE_SIGN_UP } from '@hungryroot/page-signup';
import { segmentAnalytics, Utm } from '@hungryroot/segment';
import { BreakpointSizeLarge } from '@hungryroot/tokens';
import {
  PlanContainer,
  planContentHeader,
} from '../../components/PlanContainer/PlanContainer';
import { Quiz } from './Components/Quiz/Quiz';

const WINDOW_LOCATION_REDIRECT_ROUTES = [ROUTE_SIGN_UP, ROUTE_CYO];

interface Props {
  testid?: string;
}

export function QuizComponent({ testid }: Props) {
  const history = useHistory();
  const funnelRedirects = useFunnelRedirects();

  // Add user and experiments to datadog
  useLogUser();
  useLogExperiments();

  // log a page view to segment
  // everytime the path changes
  useEffect(() => {
    segmentAnalytics.page();
  }, [location.pathname]);

  useEffect(() => {
    if (window.DD_RUM === undefined) {
      return;
    }
    initializeDatadog(window.DD_RUM);
  }, []);

  if (funnelRedirects === null) {
    return null;
  }

  const { afterBuilding, afterQuiz, beforePlan } = funnelRedirects;

  return (
    <>
      <Utm search={history.location.search} />
      <Switch>
        <Route path="/survey/plan/">
          <PlanContainer
            onBackButtonClick={() => {
              if (WINDOW_LOCATION_REDIRECT_ROUTES.includes(beforePlan)) {
                fullPageRedirect(beforePlan);
                return;
              }

              history.push(beforePlan);
            }}
            pageHeader={planContentHeader}
          />
        </Route>
        <Route path={BUILDING_PATH}>
          <Building
            onComplete={fullPageRedirect}
            redirectPath={afterBuilding}
            image={
              <picture>
                <source
                  srcSet="/public/img/home_exp_89/value-props/crystalball-desktop-light-green.gif"
                  media={`(min-width: ${BreakpointSizeLarge})`}
                />
                <img
                  src="/public/img/home_exp_89/value-props/crystalball-mobile-light-green.gif"
                  alt=""
                  height="160"
                  width="160"
                />
              </picture>
            }
            exp154Image={
              <picture>
                <img
                  src="/public/img/quiz/foodRibbonImage.gif"
                  alt=""
                  height="110"
                  width="200"
                />
              </picture>
            }
          />
        </Route>
        <Route>
          <Quiz
            testid={testid}
            onQuizComplete={() => {
              if (WINDOW_LOCATION_REDIRECT_ROUTES.includes(afterQuiz)) {
                fullPageRedirect(afterQuiz);
                return;
              }
              history.push(afterQuiz);
            }}
          />
        </Route>
      </Switch>
    </>
  );
}
